import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Controller, Zoom } from 'swiper/modules';
import { debounce } from '../utils/index';

Swiper.use([Navigation, Pagination, Thumbs, Controller, Zoom]);

export default class Slider {
    constructor(selector, options, isProductList = false) {
        const domElList = document.querySelectorAll(selector);

        if (!domElList.length) {
            return;
        }

        this.domElArr = Array.from(domElList);
        this.selector = selector;
        this.options = options;
        this.options.module = [Navigation, Pagination, Thumbs, Controller, Zoom];
        this.isProductList = isProductList;
        this.swiperList = [];
        this.swiper = null;
        this.init();
        this.sliderDisable();
        this.addMediaListener();
    }

    init() {
        this.domElArr.forEach((domEl) => {
            this.swiper = new Swiper(domEl, this.options);
            this.swiperList.push(this.swiper);
        });
    }

    sliderDisable() {
        if (this.isProductList) {
            this.swiperList.forEach((swiper) => {
                const slides = swiper.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate'));

                if (slides.length <= swiper.params.slidesPerView) {
                    swiper.el.classList.add('slider-disabled');
                    swiper.disable();
                    swiper.loopDestroy();
                } else if (!swiper.enabled) {
                    swiper.el.classList.remove('slider-disabled');
                    swiper.enable();
                    swiper.loopCreate();
                }

                swiper.update();
            });
        }
    }

    sliderBlocking(triger = true) {
        this.swiperList.forEach((swiper) => {
            if (!triger) {
                swiper.allowTouchMove = true;
                swiper.followFinger = true;

                if (swiper?.navigation?.nextEl?.style) {
                    swiper.navigation.nextEl.style.visibility = 'visible';
                } else {
                    swiper.navigation.nextEl[0].style.visibility = 'visible';
                }

                if (swiper?.navigation?.prevEl?.style) {
                    swiper.navigation.prevEl.style.visibility = 'visible';
                } else {
                    swiper.navigation.prevEl[0].style.visibility = 'visible';
                }

                return;
            }

            swiper.allowTouchMove = false;
            swiper.followFinger = false;

            if (swiper?.navigation?.nextEl?.style) {
                swiper.navigation.nextEl.style.visibility = 'hidden';
            } else {
                swiper.navigation.nextEl[0].style.visibility = 'hidden';
            }

            if (swiper?.navigation?.prevEl?.style) {
                swiper.navigation.prevEl.style.visibility = 'hidden';
            } else {
                swiper.navigation.prevEl[0].style.visibility = 'hidden';
            }
        });
    }

    addMediaListener() {
        window.addEventListener(
            'resize',
            debounce(() => {
                this.sliderDisable();
            }),
        );
    }
}
